/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.6.0",
  "gitBuildTime": "2026-05-25T14:47:12.470Z",
  "gitBuildVersion": "1.6.0",
  "gitCommitId": "265d0b1",
  "gitCommitIdFull": "265d0b1b2478b4880fe00da340a2a412ae4ac8cd",
  "gitCommitTime": "2026-05-25T14:45:48.000Z",
  "version": "1.6.0-2026-05-25T14:45:48.000Z-(265d0b1)"
};
